export default class TermPeriodService {
  constructor(http) {
    this.http = http;
  }

  async findAllTermPeriod(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/termdates/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createTermPeriod(data) {
    return this.http.fetch(`/api/termdates/create`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateTermPeriod(data) {
    return this.http.fetch(`/api/termdates/update`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async deleteTermPeriod(id) {
    return this.http.fetch(`/api/termdates/delete`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }
}
